import { AppPermission } from "@/utils/types";
import {
  Users,
  Cpu,
  Building,
  LayoutDashboard,
  ClipboardList,
  Settings,
  History,
  Computer,
  FolderKanban,
  TriangleAlert
} from "lucide-react";

export interface NavItem {
  href?: string | ((id: string) => string);
  label: string;
  icon?: React.ForwardRefExoticComponent<any>; //React.ReactNode;
  permissions?: AppPermission[];
  type?: "label" | "recentProject";
}

export const navItems: NavItem[] = [
  {
    href: "/dashboard",
    label: "Dashboard",
    //icon: <LayoutDashboard className="h-5 w-5" />
    icon: LayoutDashboard
  },
  {
    href: "/projects",
    label: "Projects",
    //icon: <FolderKanban className="h-5 w-5" />
    icon: FolderKanban
  },
  {
    label: "Recent Project",
    //icon: <History className="h-5 w-5" />,
    icon: History,
    href: (id: string) => id && `/projects/${id}`,
    type: "recentProject"
  },
  {
    href: "/assets",
    label: "Assets",
    //icon: <Computer className="h-5 w-5" />
    icon: Computer
  },
  {
    href: "/alerts",
    label: "Alerts",
    icon: TriangleAlert // You may want to use a different icon
  },
  {
    label: "Management",
    permissions: ["organisation:manage", "device:manage", "user:manage"],
    type: "label"
  },
  {
    href: "/admin/organisations",
    label: "Organisations",
    //icon: <Building className="h-5 w-5" />,
    icon: Building,
    permissions: ["organisation:manage"]
  },
  {
    href: "/admin/devices",
    label: "Devices",
    //icon: <Cpu className="h-5 w-5" />,
    icon: Cpu,
    permissions: ["device:manage"]
  },
  {
    href: "/admin/users",
    label: "Users",
    //icon: <Users className="h-5 w-5" />,
    icon: Users,
    permissions: ["user:manage"]
  },
  {
    href: "/admin/sessions",
    label: "User Sessions",
    //icon: <ClipboardList className="h-5 w-5" />,
    icon: ClipboardList,
    permissions: ["user:manage"]
  },
  { label: "Global Admin", permissions: ["profile:manage"], type: "label" },
  {
    href: "/admin/profiles",
    label: "Device Profiles",
    //icon: <Settings className="h-5 w-5" />,
    icon: Settings,
    permissions: ["profile:manage"]
  }
];
